import { OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Globals } from '../objects/Globals';
import { HeaderService } from '../services/header.service';
import { LoginService } from '../services/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TokenManager } from '../Globals';
import { SlicePipe, DatePipe } from '@angular/common';
import { ToasterService, BodyOutputType } from 'angular2-toaster';
import { NgProgress } from '@ngx-progressbar/core';
import { ToasterMessageService } from '../services/toaster-message.service';
import { ThemeSettingService } from '../services/theme-setting.service';
import { Toaster } from '../objects/ToasterObject';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { MainLoadingService } from '../services/main-loading.service';
import { EnvService } from '../env.service';
import { ModalControlService } from '../services/modal-control.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SessionTimerService } from '../services/session-timer.service';
import { AttachmentService } from '../services/attachment.service';
import { WorkflowReturnService } from '../services/workflow-return.service';
import introJs from 'intro.js/intro.js';
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(tokenManager, progress, globals, headerService, loginService, router, route, toasterService, toasterMessageService, themeSettingService, modalService, mainLoadingService, env, modalControlService, sanitizer, sessionTimerService, attachmentService, workflowReturnService) {
        var _this = this;
        this.tokenManager = tokenManager;
        this.progress = progress;
        this.globals = globals;
        this.headerService = headerService;
        this.loginService = loginService;
        this.router = router;
        this.route = route;
        this.toasterMessageService = toasterMessageService;
        this.themeSettingService = themeSettingService;
        this.modalService = modalService;
        this.mainLoadingService = mainLoadingService;
        this.env = env;
        this.modalControlService = modalControlService;
        this.sanitizer = sanitizer;
        this.sessionTimerService = sessionTimerService;
        this.attachmentService = attachmentService;
        this.workflowReturnService = workflowReturnService;
        this.groupList = [];
        this.navbarOpen = false;
        this.loginNavbarOpen = false;
        this.collapse = "closed";
        this.isBusy = false;
        this.getDate = false;
        this.isHomeClicked = false;
        this.toggleTray = false;
        this.notifications = [];
        this.hasNotification = false;
        this.notificationCount = 0;
        this.hasNewNotifications = false;
        this.displayMenu = true;
        this.hasSession = false;
        this.communityList = [];
        this.menuActions = [];
        this.languageList = [];
        this.startPage = false;
        this.isFetching = false;
        this.lastPageNotification = false;
        this.shortHeader = false;
        this.headersOrder = [];
        // downloadFile(blob: any, fileName:string): void {
        //   const objectUrl: string = URL.createObjectURL(blob);
        //   const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
        //   a.href = objectUrl;
        //   a.download = fileName;
        //   document.body.appendChild(a);
        //   a.click();        
        //   document.body.removeChild(a);
        //   URL.revokeObjectURL(objectUrl);
        // }
        // openPopup(id:string, title: string) {
        //   const config: ModalOptions = {
        //     keyboard: false,
        //     ignoreBackdropClick: true,
        //     class: 'modal-dialog-centered modal-detail',
        //     initialState: {
        //       componentId: id,
        //       title: title
        //     }
        //   };
        //   this.modalRef = this.modalService.show(DetailPopupComponent, config);
        // }
        this.showCompanyLogo = true;
        this.allowRegistration = this.env.allowRegistration;
        this.portalTitle = this.env.portalTitle;
        this.allowContactUs = this.env.allowContactUs;
        this.userGuide = this.env.allowSupplierApplication;
        this.userGuidesHtml = this.env.userGuidesHtml;
        this.shortHeader = this.env.shortHeader;
        this.headersOrder = this.env.headersOrder;
        this.logoutURL = this.env.logoutURL;
        document.addEventListener('click', this.offClickHandler.bind(this));
        this.toasterService = toasterService;
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };
        this.loggedIn = loginService.loggedIn$.subscribe(function (session) {
            if (session) {
                _this.getRequiredInfo(session);
                if (_this.subClock) {
                    if (_this.subClock.closed) {
                        var timer = Observable.timer(1000, 1000);
                        _this.subClock = timer.subscribe(function (t) { return _this.UpdateClock(); });
                    }
                }
                if (_this.subSyncTime) {
                    if (_this.subSyncTime.closed) {
                        var timer = Observable.timer(1000, 10000);
                        _this.subSyncTime = timer.subscribe(function (t) { return _this.SyncTimeWithServer(); });
                    }
                }
            }
            else {
                if (_this.subClock) {
                    _this.subClock.unsubscribe();
                }
                if (_this.subSyncTime) {
                    _this.subSyncTime.unsubscribe();
                }
                _this.notificationCount = 0;
            }
        });
        this.subHeaderMenu = headerService.headerMenuChanged$.subscribe(function (displayMenu) {
            _this.displayMenu = displayMenu;
        });
        this.subRouter = router.events.subscribe(function (val) {
            if (router.url.indexOf("/khamis/start") > -1 || router.url.indexOf("/home") > -1) {
                _this.startPage = true;
            }
            else {
                _this.startPage = false;
            }
        });
    }
    HeaderComponent.prototype.offClickHandler = function (event) {
        if (this.tray) {
            if (!this.trayicon.nativeElement.contains(event.target)) {
                if (!this.tray.nativeElement.contains(event.target)) {
                    this.toggleTray = false;
                }
            }
        }
    };
    HeaderComponent.prototype.onResize = function (event) {
        if (event.target.innerWidth < 992) {
            this.navbarOpen = false;
        }
    };
    HeaderComponent.prototype.changeTheme = function (color, accentColor, secColor) {
        document.body.style.setProperty('--primary', color);
        document.body.style.setProperty('--accent', accentColor);
        document.body.style.setProperty('--secondary', secColor ? secColor : '#edf7fd');
        this.themeSettingService.setTheme({
            animationType: ngxLoadingAnimationTypes.threeBounce,
            backdropBackgroundColour: 'rgba(255, 255, 255,0.2)',
            backdropBorderRadius: '10px',
            primaryColour: color,
            secondaryColour: color,
            tertiaryColour: color,
            accentColour: accentColor
        });
    };
    HeaderComponent.prototype.ngOnInit = function () {
        this.progressRef = this.progress.ref('progressBar');
        this.currentMenu = null;
        this.loaderConfig = this.themeSettingService.getTheme();
    };
    HeaderComponent.prototype.ngAfterViewInit = function () {
    };
    HeaderComponent.prototype.ngOnDestroy = function () {
        if (this.subClock)
            this.subClock.unsubscribe();
        if (this.subSyncTime)
            this.subSyncTime.unsubscribe();
        if (this.loggedIn)
            this.loggedIn.unsubscribe();
        if (this.subRouter)
            this.subRouter.unsubscribe();
        if (this.subHeaderMenu)
            this.subHeaderMenu.unsubscribe();
    };
    HeaderComponent.prototype.getRequiredInfo = function (session) {
        var _this = this;
        if (this.globals.Session) {
            if (this.globals.Session.Session.SessionId != this.currentSessionId) {
                this.menuActionId = "";
                this.notifications = [];
                this.hasNotification = false;
                this.showCompanyLogo = true;
                this.getUnreadCount();
                this.getLanguages();
                if (this.communityList.length == 0) { }
                this.headerService.getUserCommunities().subscribe(function (result) {
                    _this.communityList = JSON.parse(result);
                    if (_this.communityList.length > 0) {
                        _this.communityList.find(function (x) { return x.SelectionValue == _this.globals.Session.Session.CommunityId; }).IsSelected = true;
                        _this.currentCommunityId = _this.communityList.find(function (x) { return x.SelectionValue == _this.globals.Session.Session.CommunityId; }).SelectionValue;
                        _this.currentCommunity = _this.communityList.find(function (x) { return x.SelectionValue == _this.globals.Session.Session.CommunityId; }).SelectionDisplay;
                    }
                });
            }
            this.currentSessionId = this.globals.Session.Session.SessionId;
        }
    };
    HeaderComponent.prototype._checkPath = function () {
    };
    HeaderComponent.prototype.getMenuActions = function () {
        var _this = this;
        if (!this.menuActionId) {
            var groupName = "MyMenu";
            this.headerService.createMenuCard(groupName).subscribe(function (id) {
                _this.menuActionId = id;
                _this.headerService.getMenuCardMenuActions(_this.menuActionId).subscribe(function (result) {
                    if (result) {
                        var actionsGroup = JSON.parse(result);
                        if (actionsGroup[0]) {
                            _this.menuActions = actionsGroup[0].Actions;
                        }
                    }
                });
            });
        }
    };
    HeaderComponent.prototype.selectMenuAction = function (actionCommand) {
        var _this = this;
        this.mainLoadingService.setLoading(true);
        document.querySelectorAll(".backdrop").item(0).classList.add("main");
        this.headerService.selectMenuCardMenuAction(this.menuActionId, actionCommand).subscribe(function (result) {
            _this.mainLoadingService.setLoading(false);
            _this.handleWorkflowReturn(result);
        }, function (error) {
            _this.mainLoadingService.setLoading(false);
        });
    };
    HeaderComponent.prototype.changeCommunity = function (community) {
        var _this = this;
        this.headerService.changeCommunity(community.SelectionValue).subscribe(function (result) {
            if (result) {
                if (result == "1") {
                    _this.showCompanyLogo = true;
                    _this.currentCommunityId = community.SelectionValue;
                    _this.currentCommunity = community.SelectionDisplay;
                    //get new session and redirect to home
                    var sessionCookie = JSON.parse(_this.tokenManager.retrieve("BRNSessionKey"));
                    _this.loginService.getSession(sessionCookie).subscribe(function (result) {
                        _this.redirectHome(JSON.parse(result));
                    });
                }
            }
        });
    };
    HeaderComponent.prototype.redirectHome = function (result) {
        this.globals.CardItems = [];
        this.globals.Session.Session = result.SessionObject.Session;
        this.loginService.setSession(result);
        this.router.navigate(['/', 'home']);
        document.querySelectorAll('.body-content').item(0).classList.remove('mb-login');
        document.querySelectorAll(".body-content").item(0).classList.remove('default');
        document.querySelectorAll('.navbar').item(0).classList.remove('mb-login');
        this.tokenManager.delete("BRNCurrentMenu");
        if (this.globals.Session.Session.SessionId != null) {
            this.tokenManager.store('BRNSessionKey', this.globals.Session.Session.SessionId);
        }
        // this.toasterService.clear();
    };
    HeaderComponent.prototype.ngAfterViewChecked = function () {
        if (this.globals.Session) {
            this.getTimeZoneList();
        }
    };
    HeaderComponent.prototype.getTime = function () {
        var _this = this;
        if (!this.getDate) {
            if (this.globals.Session) {
                this.getDate = true;
                this.headerService.getTime().subscribe(function (result) {
                    var slicedValue = new SlicePipe().transform(result, 6, -2);
                    _this.datePipe = new DatePipe("en-US").transform(new Date(parseInt(slicedValue)), 'dd MMM yyyy hh:mm:ss a');
                    var clockTimer = Observable.timer(1000, 1000);
                    _this.subClock = clockTimer.subscribe(function (t) { return _this.UpdateClock(); });
                    var syncTime = Observable.timer(1000, 10000);
                    _this.SyncTimeWithServer();
                    _this.subSyncTime = syncTime.subscribe(function (t) { return _this.SyncTimeWithServer(); });
                });
            }
        }
    };
    HeaderComponent.prototype.goToDashboard = function () {
        this.router.navigate(['/']);
        this.tokenManager.store("BRNCurrentRoute", "/");
    };
    HeaderComponent.prototype.UpdateClock = function () {
        if (this.globals.Session) {
            var date = new Date(this.datePipe);
            var incre = date.setSeconds(date.getSeconds() + 1);
            this.headerService.setCurrentUserDateTime(new Date(parseInt(incre)));
            this.datePipe = new DatePipe("en-US").transform(new Date(parseInt(incre)), 'dd MMM yyyy hh:mm:ss a');
        }
    };
    HeaderComponent.prototype.SyncTimeWithServer = function () {
        var _this = this;
        if (this.globals.Session) {
            this.headerService.getTime().subscribe(function (result) {
                var slicedValue = new SlicePipe().transform(result, 6, -2);
                _this.headerService.setCurrentUserDateTime(new Date(parseInt(slicedValue)));
                _this.datePipe = new DatePipe("en-US").transform(new Date(parseInt(slicedValue)), 'dd MMM yyyy hh:mm:ss a');
            }, function (error) {
                _this.handleError(error);
            });
            // checkNotifications too every 10 seconds
            this.checkNotifications();
        }
    };
    HeaderComponent.prototype.checkNotifications = function () {
        var _this = this;
        //new notifications card
        if (this.notifications.length > 0) {
            this.getUnreadCount();
            this.headerService.getLatestNotificationDate().subscribe(function (result) {
                if (result == "1") {
                    _this.headerService.getNotifications().subscribe(function (notification) {
                        _this.lastPageNotification = false;
                        _this.notifications = JSON.parse(notification);
                        _this.notifications.forEach(function (notification) {
                            if (notification.IsForcePrompt && !notification.IsRead) {
                                _this.toasterMessageService.popToast(notification.NotificationTitle, notification.NotificationMessage, notification.NotificationType);
                                _this.headerService.MarkOneNotificationAsRead(notification.NotificationId).subscribe(function (result) {
                                    // thanks
                                });
                            }
                        });
                        _this.markAsRead();
                    });
                }
            });
        }
        else {
            this.headerService.getNotifications().subscribe(function (notification) {
                _this.lastPageNotification = false;
                _this.notifications = JSON.parse(notification);
                _this.markAsRead();
            });
        }
    };
    HeaderComponent.prototype.getUnreadCount = function () {
        var _this = this;
        this.headerService.getUnreadCount().subscribe(function (result) {
            var count = parseInt(result);
            _this.notificationCount = count;
            if (count > 0) {
                _this.hasNotification = true;
            }
            else {
                _this.hasNotification = false;
            }
        }, function (error) {
            _this.handleError(error);
        });
    };
    HeaderComponent.prototype.sortNotifications = function (notifications) {
        this.notifications = notifications.sort(function (a, b) {
            if (a.NotificationDate < b.NotificationDate) {
                return 1;
            }
            else if (a.NotificationDate > b.NotificationDate) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    HeaderComponent.prototype.updateProfile = function () {
        var _this = this;
        this.mainLoadingService.setLoading(true);
        this.headerService.updateProfile().subscribe(function (result) {
            _this.mainLoadingService.setLoading(false);
            _this.handleWorkflowReturn(result);
        });
    };
    HeaderComponent.prototype.changePassword = function () {
        var _this = this;
        this.mainLoadingService.setLoading(true);
        this.headerService.changePassword().subscribe(function (result) {
            _this.mainLoadingService.setLoading(false);
            _this.handleWorkflowReturn(result);
        });
    };
    HeaderComponent.prototype.goToHome = function () {
        var _this = this;
        if (!this.startPage) {
            this.tokenManager.store("BRNCurrentMenu", "Home");
            this.mainLoadingService.setProgressBar(true);
            // this.progressRef.start();
            this.loginService.getHomePage().subscribe(function (result) {
                _this.mainLoadingService.setProgressBar(false);
                var command = JSON.parse(result);
                _this.workflowReturnService.handleWorkflowReturn(command, true, true);
            }, function (error) {
                _this.progressRef.complete();
            });
        }
    };
    HeaderComponent.prototype.toggleNavbar = function () {
        this.navbarOpen = !this.navbarOpen;
    };
    HeaderComponent.prototype.toggleLoginNavbar = function () {
        this.loginNavbarOpen = !this.loginNavbarOpen;
    };
    HeaderComponent.prototype.logOutSession = function () {
        var _this = this;
        this.mainLoadingService.setLoading(true);
        this.headerService.setSessionAlive(false);
        this.sessionTimerService.stopSessionTimer();
        this.headerService.endSession().subscribe(function (result) {
            if (result == "1") {
                _this.popToast("Info", "Your session has ended", "info");
            }
            _this.mainLoadingService.setLoading(false);
            _this.clear();
            if (_this.logoutURL && _this.logoutURL.trim() !== '') {
                window.location.href = _this.logoutURL;
                return;
            }
            else {
                _this.router.navigate(['/login']);
            }
        }, function (error) {
            _this.mainLoadingService.setLoading(false);
            _this.popToast("Error", "Unable to process action", "error");
        });
    };
    HeaderComponent.prototype.clear = function () {
        this.globals.Session = null;
        this.tokenManager.clear();
        this.menuActions = [];
        this.currentMenu = null;
        this.loginNavbarOpen = false;
        this.navbarOpen = false;
        this.progressRef.complete();
        this.toggleTray = false;
        this.notifications = [];
        this.toasterMessageService.clearToaster();
        this.mainLoadingService.setProgressBar(false);
        this.loginService.setSession(null);
    };
    HeaderComponent.prototype.handleError = function (error) {
        if (error.status == 0) {
            this.loginService.setSession(null);
        }
    };
    HeaderComponent.prototype.popToast = function (title, body, type) {
        var _this = this;
        var toast = {
            type: type,
            title: title,
            body: body,
            showCloseButton: true,
            bodyOutputType: BodyOutputType.TrustedHtml,
            onShowCallback: function (toast) {
                var toaster = new Toaster();
                toaster.id = toast.toastId;
                toaster.timestamp = Date.now();
                toaster.title = toast.title;
                toaster.content = toast.body;
                _this.toasterMessageService.pushToaster(toaster);
            }
        };
        this.toasterService.pop(toast);
    };
    HeaderComponent.prototype.getTimeZoneList = function () {
        var _this = this;
        if (this.timeZoneList == null && !this.isBusy) {
            this.isBusy = true;
            this.headerService.getTimeZoneList().subscribe(function (result) {
                _this.timeZoneList = JSON.parse(result);
                _this.timeZoneList.forEach(function (obj) {
                    if (obj.Id == _this.globals.Session.Session.TimeZoneSetting) {
                        _this.timeZoneName = obj.Id;
                    }
                });
                if (_this.timeZoneName == null) {
                    _this.timeZoneName = _this.timeZoneList[0].TimeZoneName;
                }
                _this.getTime();
            });
        }
    };
    HeaderComponent.prototype.onTimeZoneChange = function (event) {
        var _this = this;
        this.headerService.setTimeZone(event).subscribe(function (result) {
            if (result == "1") {
                _this.popToast("Timezone updated", "Please re login to see the change", "warning");
            }
        });
    };
    HeaderComponent.prototype.getLanguages = function () {
        var _this = this;
        this.headerService.createLanguageCard().subscribe(function (id) {
            if (id) {
                _this.languageCardId = id;
                _this.headerService.getLanguages(id).subscribe(function (result) {
                    _this.languageList = JSON.parse(result);
                    _this.currentLanguage = _this.languageList.find(function (x) { return x.SelectionValue == _this.globals.Session.Session.LanguageSetting; }).SelectionValue;
                    _this.currentLanguageDisplay = _this.languageList.find(function (x) { return x.SelectionValue == _this.globals.Session.Session.LanguageSetting; }).SelectionDisplay;
                });
            }
        });
    };
    HeaderComponent.prototype.selectLanguage = function (locale) {
        var _this = this;
        this.mainLoadingService.setLoading(true);
        this.headerService.selectLanguage(this.languageCardId, locale).subscribe(function (result) {
            _this.mainLoadingService.setLoading(false);
            _this.handleWorkflowReturn(result);
        }, function (error) {
            _this.mainLoadingService.setLoading(false);
        });
    };
    HeaderComponent.prototype.showNotification = function () {
        var _this = this;
        this.toggleTray = !this.toggleTray;
        if (this.toggleTray) {
            this.headerService.getNotifications().subscribe(function (notification) {
                _this.lastPageNotification = false;
                _this.notifications = JSON.parse(notification);
                _this.markAsRead();
            });
        }
        // toasters from angular
        var items = this.toasterMessageService.getToaster();
        this.toasters = items.sort(this.sortToaster);
    };
    HeaderComponent.prototype.markAsRead = function () {
        var _this = this;
        if (this.toggleTray) {
            this.notifications.forEach(function (noti) {
                noti.IsRead = true;
            });
            this.notificationCount = 0;
            this.headerService.markNotificationsRead().subscribe(function (result) {
                if (result == "1") {
                    setTimeout(function () {
                        // wont call a new one to get new notifications, because it should already be the latest, once there's new notifications it will call this if opened
                        // so in this case, current notifications will be changed to read
                        _this.getUnreadCount();
                    });
                }
            });
        }
    };
    HeaderComponent.prototype.selectNotification = function (id) {
        var _this = this;
        this.mainLoadingService.setLoading(true);
        this.headerService.selectNotification(id).subscribe(function (result) {
            if (result) {
                _this.handleWorkflowReturn(result);
                _this.toggleTray = false;
            }
            else {
                _this.mainLoadingService.setLoading(false);
            }
        }, function (error) {
            _this.mainLoadingService.setLoading(false);
        });
    };
    HeaderComponent.prototype.sortToaster = function (a, b) {
        if (a.timestamp > b.timestamp)
            return -1;
        if (a.timestamp < b.timestamp)
            return 1;
        return 0;
    };
    HeaderComponent.prototype.fetchMore = function (event) {
        var _this = this;
        if (this.lastPageNotification)
            return;
        if (event.endIndex == this.notifications.length - 1) {
            if (!this.isFetching) {
                this.isFetching = true;
                this.fetchNextChunk(this.notifications.length, 10).then(function (chunk) {
                    if (chunk.length == _this.notifications.length)
                        _this.lastPageNotification = true;
                    _this.notifications = chunk;
                    _this.isFetching = false;
                }, function () { return _this.isFetching = false; });
            }
        }
        ;
    };
    HeaderComponent.prototype.fetchNextChunk = function (skip, limit) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.headerService.notificationsNextPage().subscribe(function (result) {
                if (result == "1") {
                    _this.headerService.getNotifications().subscribe(function (notifications) {
                        var newNotifications = JSON.parse(notifications);
                        resolve(newNotifications);
                    });
                }
            });
        });
    };
    HeaderComponent.prototype.startTour = function () {
        // var intro:any = introJs.introJs();
        // intro.setOptions({
        //   steps: [
        // {
        //   element: '#GoToQP_link',
        //   intro: 'Click this menu to see the quick phrase page',
        //   position: 'right'
        // },
        // {
        //   element: '#GoToPG_link',
        //   intro: 'Click this menu to get to product management page',
        //   position: 'right'
        // },
        // {
        //   element: '#DBPending-M_AttentionItems',
        //   intro: 'This is the attention items'
        // },
        // {
        //   element: "#card-pending-0",
        //   intro: 'Open tender',
        //   position: 'left'
        // },
        // {
        //   element: '#search',
        //   intro: 'Global search',
        //   position: 'bottom'
        // }
        //   ],
        //   showBullets: true,
        //   showButtons: true,
        //   exitOnOverlayClick: false,
        //   showStepNumbers: false,
        //   keyboardNavigation: true,
        //   overlayOpacity: 0.8,
        //   doneLabel: 'X',
        //   skipLabel: 'X',
        //   highlightClass: "helper-layer"
        // });
        // intro.start();
        var path = this.router.url;
        this.headerService.getPageTour(path).subscribe(function (steps) {
            var bigSteps = JSON.parse(steps);
            if (steps) {
                // bigSteps.forEach(step => {
                //   console.log(step.element);
                //   var matches = step.element.match(/\{(.*?)\}/g);
                //   console.log(matches);
                //   if (matches){
                //     matches.forEach(match => {
                //       var className = match.split('|')[0].replace('{', '').replace('}','');
                //       var order = match.split('|')[1];
                //       step.element = step.element.replace(match.split('|')[0], document.querySelectorAll(className)[0] as HTMLElement);
                //       console.log(step.element);
                //       console.log(step);
                //     });
                //   }
                // });
                // console.log(bigSteps);
                var intro = introJs();
                intro.setOptions({
                    steps: bigSteps,
                    showBullets: true,
                    showButtons: true,
                    exitOnOverlayClick: true,
                    showStepNumbers: false,
                    keyboardNavigation: true,
                    overlayOpacity: 0.7,
                    doneLabel: 'X',
                    skipLabel: 'X',
                    highlightClass: "helper-layer"
                });
                intro.start();
            }
        });
    };
    HeaderComponent.prototype.handleWorkflowReturn = function (result) {
        var _this = this;
        var command = JSON.parse(result);
        if (command.ReturnType == 7) {
            this.attachmentService.downloadFile(command.Arguments[0]).subscribe(function (data) {
                _this.workflowReturnService.downloadFile(data, command.Arguments[1]);
                _this.mainLoadingService.setLoading(false);
            }, function (error) {
                _this.mainLoadingService.setLoading(false);
            });
        }
        else {
            this.workflowReturnService.handleWorkflowReturn(command);
            this.mainLoadingService.setLoading(false);
        }
        // switch(command.ReturnType){
        //   case 0: // navigate
        //     if(command.Arguments){
        //       var path = [];
        //       command.Arguments.forEach(element => {
        //         path.push(element);
        //       });
        //       this.router.navigate(path);
        //     }
        //     break;
        //   case 1: //message
        //     this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
        //     break;
        //   case 2: //reload, does nothing, depends on refreshtype
        //     break;
        //   case 3: //open popup
        //     this.openPopup(command.Arguments[0], command.Arguments[1]);
        //     break;
        //   case 4: //message
        //     var list = ["parent", "all"];
        //     if (list.filter(x => x == command.RefreshType).length == 0){
        //       this.modalService.hide(this.modalService.getModalsCount() - 1);
        //     }
        //     this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
        //     if (command.Arguments[2]){
        //       this.openPopup(command.Arguments[2], "");
        //     }
        //     break;
        //   case 5: //summary popup
        //     this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "summary", "modal-summary");
        //     break;
        //   case 6: //comparison
        //     this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "compare");
        //     break;
        //   case 7: //download file
        //     this.attachmentService.downloadFile(command.Arguments[0]).subscribe(data=>{
        //       this.downloadFile(data, command.Arguments[1]);
        //     });
        //   break;
        // }
    };
    HeaderComponent.prototype.onErrorImage = function (event) {
        this.showCompanyLogo = false;
    };
    return HeaderComponent;
}());
export { HeaderComponent };
